module.exports = __webpack_public_path__ + "static/media/logo.d71bca88.webp";